import _BrowserRouter from './BrowserRouter';
export { _BrowserRouter as BrowserRouter };
import _HashRouter from './HashRouter';
export { _HashRouter as HashRouter };
import _Link from './Link';
export { _Link as Link };
import _MemoryRouter from './MemoryRouter';
export { _MemoryRouter as MemoryRouter };
import _NavLink from './NavLink';
export { _NavLink as NavLink };
import _Prompt from './Prompt';
export { _Prompt as Prompt };
import _Redirect from './Redirect';
export { _Redirect as Redirect };
import _Route from './Route';
export { _Route as Route };
import _Router from './Router';
export { _Router as Router };
import _StaticRouter from './StaticRouter';
export { _StaticRouter as StaticRouter };
import _Switch from './Switch';
export { _Switch as Switch };
import _matchPath from './matchPath';
export { _matchPath as matchPath };
import _withRouter from './withRouter';
export { _withRouter as withRouter };


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/es/index.js
// module id = 440
// module chunks = 4